import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getPostsByLang } from "../data/posts";
import { useLocale } from "../context/LocaleContext";
import "../styles/root.css";

function News() {
  const { lang, t } = useLocale();
  const posts = getPostsByLang(lang);
  const newsItems = [...posts].sort(
    (a, b) => new Date(b.date) - new Date(a.date),
  );

  return (
    <div>
      <Navbar />
      <div className="home-container">
        <h1 className="headline">{t.news.headline}</h1>
        <div className="news-grid">
          {newsItems.map((post) => (
            <article className="news-card" key={post.slug}>
              <Link to={`/news/${post.slug}`} className="news-card-link">
                <img
                  className="news-card-thumbnail"
                  src={post.mainImage.src}
                  alt={post.mainImage.alt}
                />
                <div className="news-card-content">
                  <h2>{post.title}</h2>
                  <p className="news-card-meta">
                    {new Date(post.date).toLocaleDateString(
                      lang === "mk" ? "mk-MK" : "en-GB",
                      {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      },
                    )}
                  </p>
                  <p>{post.excerpt}</p>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default News;
